<template>
  <v-data-table
    :headers="headers"
    :items="deliveryNotes"
    class="elevation-1"
    :loading="isLoading"
    sort-by="deliveryNote.receivingDate"
    :sort-desc="true"
  >
    <template v-slot:item.deliveryNote.receivingDate="{ item }">
      {{ formatDate(item.receivingDate) }}
    </template>
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="DeliveryNote-button-new"
          @click="$router.push({
            name: 'processing-EditDeliveryNote'
          })"
        >
          {{ $$t('new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row no-gutters>
        <v-col cols="12" xl="6" lg="6">
          <v-btn
            block
            v-if="item.state !== 'Received'"
            small color="primary" :to="{
                name: 'processing-EditDeliveryNote',
                query: {id: item.id}
              }">
            <v-icon
              small
              class="mr-2"
              :data-cy="`button-DeliveryNote-edit-${item.goodsReceivedNumber}`"
            >
              {{ mdiPencil }}
            </v-icon>
            Edit
          </v-btn>
          <v-btn
            block
            v-else
            small color="primary" :to="{
                name: 'processing-EditDeliveryNote',
                query: {id: item.id}
              }">
            <v-icon
              small
              class="mr-2"
              :data-cy="`button-DeliveryNote-edit-${item.goodsReceivedNumber}`"
            >
              {{ mdiEye }}
            </v-icon>
            View
          </v-btn>
        </v-col>
        <v-col cols="12" xl="6" lg="6">
          <v-btn
            small
            block
            :data-cy="`button-DeliveryNote-remove-${item.id}`"
            @click="remove(item)"
            color="error"
            v-if="item.state !== 'Received'"
          >
            <v-icon
              small
              class="mr-2"
            >
              {{ mdiDelete }}
            </v-icon>
            Delete
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiDelete, mdiEye, mdiPencil } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListDeliveryNote',
  module: 'DeliveryNote',
  mixins: [loading],
  data() {
    return {
      mdiDelete,
      mdiPencil,
      mdiEye,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('deliveryNotes', ['deliveryNotes']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('receivingDate'),
          value: 'deliveryNote.receivingDate',
        },
        {
          text: this.$$t('farmId'),
          value: 'farm.name',
        },
        {
          text: this.$$t('goodsReceivedNumber'),
          value: 'goodsReceivedNumber',
        },
        {
          text: this.$$t('farmDeliveryNoteNumber'),
          value: 'farmDeliveryNoteNumber',
        },
        {
          text: this.$$t('state'),
          value: 'state',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_deliveryNotes();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('deliveryNotes', ['LOAD_deliveryNotes', 'DELETE_deliveryNote']),
    /** Delete DeliveryNote from the collection
     */
    async remove(deliveryNote) {
      this.isLoading = true;
      await this.DELETE_deliveryNote(deliveryNote.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# DeliveryNote example

'''js
<DeliveryNote />
'''
</docs>
